import React, { Component } from "react";
import $ from "jquery";

export default class TermsText extends Component {
  state = {};

  showReviewRequestDiv() {
    $("#termsconditions").hide();

    $("#reviewrequest").show();
    $("#reviewrequest").scrollTop();
  }

  render() {
    return (
      <div className="wrapper">
        <span className="terms-back-button" onClick={this.showReviewRequestDiv}>
          Back
        </span>
        <div className="space"></div>
        <h3 className="terms-and-conditions-header">
          <strong> Terms And Conditions </strong>
        </h3>
        <ol>
          <li className="terms-list-item-text">
            You are providing and granting a royalty free, perpetual,
            irrevocable and fully transferable and sublicense license and your
            consent for the business, or their agents or representatives, at
            their own discretion to republish any or all review content
            including the potential of publishing on websites managed by the
            business.
          </li>
          <br />

          <li className="terms-list-item-text">
            You must be at least 18 years or older, have personal knowledge of
            the business based on bona fide sales and service with the business,
            you have not been compensated for this review in any manner and you
            have no relationship or affiliation with the business.
          </li>
          <br />

          <li className="terms-list-item-text">
            Your review response is accurate and honest, you are responsible for
            the content of the response and the content may be edited prior to
            posting if it is determined the content is obscene, lewd,
            lascivious, filthy, excessively violent, harassing, or otherwise
            objectionable.
          </li>
          <br />

          <li className="terms-list-item-text">
            You own all intellectual property rights (including but not limited
            to copyright, trademark and rights of publicity and privacy) in the
            content of your response.
          </li>
          <br />

          <li className="terms-list-item-text">
            The content you are submitting complies with all applicable laws and
            regulations and does not contain any personal information for anyone
            other than you. You agree to fully defend, indemnify, and hold the
            business and its officers, directors, employees, shareholders,
            customers, agents, successors and assigns harmless from and against
            any and all loss, damages, costs, claims, expenses, settlements or
            other liability (including reasonable attorneys’ fees) arising from
            an event in which the content you submit does not comply with these
            laws and regulations.
          </li>
        </ol>
        <span className="terms-back-button" onClick={this.showReviewRequestDiv}>
          Back
        </span>
      </div>
    );
  }
}
